"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validatePhoneNumber = function (value) { return (/^\+*\d{4,14}$/.test(value)); };
exports.default = validatePhoneNumber;
